import { z } from 'zod'

export const FormInsightCitationAgentInputSchema = z.object({
  type: z.literal('form_insight'),
  insightId: z.string().describe('The insightId surfaced by getFormInsights for the historical reviewer pattern being cited.'),
})

// Whole-insight grain: one citation per historical reviewer pattern, with no `citedFacts`. A form insight's
// value is analogical (a pattern reviewers have historically enforced on this question), not a quoted field
// value, so there is nothing to anchor.
export const FormInsightCitationResolvedSchema = z.object({
  sourceType: z.literal('form_insight'),
  sourceLabel: z.string(),
  insightId: z.string(),
  requestFormId: z.string(),
  formTitle: z.string(),
  questionName: z.string(),
  questionTitle: z.string(),
  title: z.string(),
  description: z.string(),
})
export type FormInsightCitationResolved = z.infer<typeof FormInsightCitationResolvedSchema>
